export enum OverTimeGraphType {
  MULTIPLE_STATISTICS = 'MULTIPLE_STATISTICS',
  MULTIPLE_ELEMENTS = 'MULTIPLE_ELEMENTS'
}
